<h2 mat-dialog-title>{{ isEdit ? 'Editar subcategoría' : 'Nueva subcategoría' }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="subcategory-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="subcategoryName" maxlength="80" />
      <mat-error *ngIf="form.get('subcategoryName')?.hasError('required')">El nombre es requerido</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Categoría</mat-label>
      <mat-select formControlName="categoryId">
        <mat-option *ngFor="let cat of categories" [value]="cat.categoryId">
          {{ cat.categoryName }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('categoryId')?.hasError('required')">La categoría es requerida</mat-error>
    </mat-form-field>

    <div class="image-row">
      <div class="image-block">
        <span class="image-label">Icono</span>
        <div class="image-preview" *ngIf="iconPreview">
          <img [src]="iconPreview" alt="icono subcategoría" />
        </div>
        <button mat-stroked-button type="button" (click)="iconInput.click()">
          <mat-icon>upload</mat-icon>
          {{ iconPreview ? 'Cambiar' : 'Subir' }}
        </button>
        <input hidden type="file" accept="image/png,image/jpg,image/jpeg,image/webp" #iconInput
               (change)="onIconSelected($event)" />
      </div>

      <div class="image-block">
        <span class="image-label">Imagen de título</span>
        <div class="image-preview" *ngIf="titleImagePreview">
          <img [src]="titleImagePreview" alt="imagen título" />
        </div>
        <button mat-stroked-button type="button" (click)="titleInput.click()">
          <mat-icon>upload</mat-icon>
          {{ titleImagePreview ? 'Cambiar' : 'Subir' }}
        </button>
        <input hidden type="file" accept="image/png,image/jpg,image/jpeg,image/webp" #titleInput
               (change)="onTitleImageSelected($event)" />
      </div>
    </div>

    <mat-checkbox formControlName="active">Subcategoría habilitada</mat-checkbox>

    <p class="hint" *ngIf="!isEdit">
      El formulario de la subcategoría se crea vacío; edítalo luego con el botón
      <mat-icon inline>dynamic_form</mat-icon> del listado.
    </p>

    <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="primary" (click)="save()">Guardar</button>
</mat-dialog-actions>
